if (!customElements.get('menu-drawer')) {
  customElements.define('menu-drawer', class MenuDrawer extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector('details');
      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.bindEvents();
    }
    bindEvents() {
      this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
    onKeyUp(event) {
      if(event.code.toUpperCase() !== 'ESCAPE') return;
      const openDetailsElement = event.target.closest('details[open]');
      if(!openDetailsElement) return;
      openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const isOpen = detailsElement.hasAttribute('open');
      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
      function addTrapFocus() {
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
        summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
      }
      if (detailsElement === this.mainDetailsToggle) {
        if (isOpen === true) {
          this.closeMenuDrawer(event, summaryElement);
        } else {
          this.openMenuDrawer(summaryElement);
          if (reducedMotion.matches) {
            trapFocus(this.mainDetailsToggle.nextElementSibling, detailsElement.querySelector('button'));
          } else {
            this.mainDetailsToggle.nextElementSibling.addEventListener('transitionend', addTrapFocus, {once: true});
          }
        }
      }
      if (detailsElement.querySelector('ul.menu-drawer__menu')) {
        event.preventDefault();
        if (isOpen) {
          this.closeSubmenu(detailsElement);
        } else {
          this.openSubmenu(summaryElement, detailsElement);
        }
      }
    }
    openMenuDrawer(summaryElement) {
      setTimeout(() => { this.mainDetailsToggle.classList.add('menu-opening'); });
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle.nextElementSibling);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
    closeMenuDrawer(event, elementToFocus = false) {
      if (event !== undefined) {
        this.mainDetailsToggle.classList.remove('menu-opening');
        this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
        });
        document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
        removeTrapFocus(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle);
      }
    }
    onFocusOut() {
      setTimeout(() => {
        if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) {
          this.closeMenuDrawer();
        }
      });
    }
    onCloseButtonClick(event) {
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    openSubmenu(summaryElement, detailsElement) {
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details !== detailsElement && details.removeAttribute('open');
      });
      setTimeout(() => { detailsElement.classList.add('menu-opening'); });
      const parentMenu = detailsElement.closest('ul');
      if (parentMenu) parentMenu.classList.add('submenu-open');
      trapFocus(detailsElement.querySelector('button'), detailsElement.querySelector('ul') || detailsElement.querySelector('.menu-drawer__submenu'));
    }
    closeSubmenu(detailsElement) {
      const parentMenu = detailsElement.closest('ul');
      if (parentMenu) parentMenu.classList.remove('submenu-open');
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;
      const handleAnimation = (time) => {
        if (animationStart === undefined) animationStart = time;
        const elapsedTime = time - animationStart;
        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
          if (detailsElement.closest('details[open]')) {
            trapFocus(detailsElement.closest('details[open]'), detailsElement.closest('details[open]').querySelector('summary'));
          }
        }
      }
      window.requestAnimationFrame(handleAnimation);
    }
  });
}

if (!customElements.get('header-drawer')) {
  customElements.define('header-drawer', class HeaderDrawer extends MenuDrawer {
    constructor() {
      super();
    }
    openMenuDrawer(summaryElement) {
      this.header = this.header || document.querySelector('.section-header');
      this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
      document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
      this.header.classList.add('menu-open');
      setTimeout(() => { this.mainDetailsToggle.classList.add('menu-opening'); });
      summaryElement.setAttribute('aria-expanded', true);
      window.addEventListener('resize', this.onResize = () => {
        window.innerWidth >= 990 && this.closeMenuDrawer();
      });
      trapFocus(this.mainDetailsToggle.nextElementSibling);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
    closeMenuDrawer(event, elementToFocus) {
      super.closeMenuDrawer(event, elementToFocus);
      this.header && this.header.classList.remove('menu-open');
      window.removeEventListener('resize', this.onResize);
    }
  });
}